import { useMyMonitoringGetDefaultMediaImages } from '@apps-common/apis/my-monitoring/site'
import { getSameFromArrayByNumber } from '@apps-common/config/get-from-array-by-index'

export const useGetDefaultSiteImage = (id?: number): { loading: boolean; defaultImageUrl: string | undefined } => {
  const { isLoading, isError, data } = useMyMonitoringGetDefaultMediaImages({ config: { staleTime: Infinity } })

  const idInvalid = !id || Number.isNaN(id)
  const loading = isLoading || isError

  return {
    loading,
    defaultImageUrl: loading || idInvalid ? undefined : getSameFromArrayByNumber(id, data || [])
  }
}
